export const legalValidation = (data) => {
  const errors = {};

  if (!data.contentHeading) {
    errors.contentHeading = 'Heading is required';
  }

  if (!data?.metaProperties?.description || data?.metaProperties?.description.trim() === '') {
    errors.metaDescription = 'Meta description is required.';
  }

  if (!data?.metaProperties?.title || data?.metaProperties?.title.trim() === '') {
    errors.metaTitle = 'Meta title is required.';
  }

  if (data?.faq?.status) {
    const faqSectionErrors = [];

    if (Array.isArray(data?.faq?.section) && data.faq.section.length > 0) {
      data.faq.section.forEach((banner, index) => {
        const bannerErrors = {};

        if (!banner.question?.trim()) {
          bannerErrors.question = "Question is required";
        }

        if (!banner.answer?.trim()) {
          bannerErrors.answer = "Answer is required";
        }

        if (Object.keys(bannerErrors).length > 0) {
          faqSectionErrors[index] = bannerErrors;
        }
      });

      if (faqSectionErrors.length > 0) {
        errors.faq = { section: faqSectionErrors };
      }
    }
  }

  const isValid = Object.keys(errors).length === 0;
  return { isValid, errors };
};
